import { HOST } from "./constants.js";

export function useInternet() {
  let headers = (data) => {
    let res = {
      Authorization: "Bearer " + window.localStorage.token,
    };
    if (data && !(data instanceof FormData)) {
      res["Content-Type"] = "application/json";
    }
    return res;
  };

  let defaultThen = (res) => {
    if (!res.ok) {
      throw res;
    }
    return res;
  };

  return {
    get: (url) => {
      return fetch(HOST + url, { headers: headers() }).then(defaultThen);
    },
    post: (url, data) => {
      return fetch(HOST + url, {
        headers: headers(data),
        method: "POST",
        body: data instanceof FormData ? data : JSON.stringify(data),
      }).then(defaultThen);
    },
    delete: (url) => {
      return fetch(HOST + url, { headers: headers(), method: "DELETE" }).then(
        defaultThen
      );
    },
  };
}
